export enum RelanceRole {
	AUTONOMOUS_MUNICIPAL_PROVINCIAL_COMPANIES = 'AUTONOMOUS_MUNICIPAL_PROVINCIAL_COMPANIES',
	COMPANIES_UNDER_PRIVATE_OR_PUBLIC_LAW = 'COMPANIES_UNDER_PRIVATE_OR_PUBLIC_LAW',
	COOPERATIONS_BETWEEN_APPLICANTS = 'COOPERATIONS_BETWEEN_APPLICANTS',
	FLEMISH_COMMUNITY_COMMISSION = 'FLEMISH_COMMUNITY_COMMISSION',
	FOUNDATIONS = 'FOUNDATIONS',
	INTERMUNICIPAL_PARTNERSHIPS = 'INTERMUNICIPAL_PARTNERSHIPS',
	LOCAL_PROVINCIAL_GOVERNMENTS = 'LOCAL_PROVINCIAL_GOVERNMENTS',
	NON_PROFIT_ORGANIZATIONS = 'NON_PROFIT_ORGANIZATIONS',
	LEGAL_ENTITY_UNDER_PRIVATE_OR_PUBLIC_LAW = 'LEGAL_ENTITY_UNDER_PRIVATE_OR_PUBLIC_LAW',
	PERSON = 'NATURAL_PERSON_WITH_COMPANY_NUMBER',
}

export const RELANCE_ROLE_TRANSLATIONS = {
	[RelanceRole.AUTONOMOUS_MUNICIPAL_PROVINCIAL_COMPANIES]: 'Autonome gemeente- en provinciebedrijven',
	[RelanceRole.COMPANIES_UNDER_PRIVATE_OR_PUBLIC_LAW]: 'Vennootschappen met rechtspersoonlijkheid van privaat of publiek recht',
	[RelanceRole.COOPERATIONS_BETWEEN_APPLICANTS]: 'Samenwerkingsverbanden tussen meerdere aanvragers',
	[RelanceRole.FLEMISH_COMMUNITY_COMMISSION]: 'Vlaamse Gemeenschapscommissie',
	[RelanceRole.FOUNDATIONS]: 'Stichtingen',
	[RelanceRole.INTERMUNICIPAL_PARTNERSHIPS]: 'Intergemeentelijke samenwerkingsverbanden met rechtspersoonlijkheid',
	[RelanceRole.LOCAL_PROVINCIAL_GOVERNMENTS]: 'Lokale en provinciale besturen',
	[RelanceRole.NON_PROFIT_ORGANIZATIONS]: 'Verenigingen zonder winstoogmerk',
	[RelanceRole.LEGAL_ENTITY_UNDER_PRIVATE_OR_PUBLIC_LAW]: 'Privaatrechtelijke en publiekrechtelijke rechtspersonen',
	[RelanceRole.PERSON]: 'Natuurlijke persoon met een ondernemingsnummer',
};

export const RELANCE_ROLES = [
	RelanceRole.FLEMISH_COMMUNITY_COMMISSION,
	RelanceRole.LOCAL_PROVINCIAL_GOVERNMENTS,
	RelanceRole.AUTONOMOUS_MUNICIPAL_PROVINCIAL_COMPANIES,
	RelanceRole.INTERMUNICIPAL_PARTNERSHIPS,
	RelanceRole.COMPANIES_UNDER_PRIVATE_OR_PUBLIC_LAW,
	RelanceRole.NON_PROFIT_ORGANIZATIONS,
	RelanceRole.FOUNDATIONS,
	RelanceRole.COOPERATIONS_BETWEEN_APPLICANTS,
	RelanceRole.LEGAL_ENTITY_UNDER_PRIVATE_OR_PUBLIC_LAW,
];

export const WO1_ROLES = [
	RelanceRole.LEGAL_ENTITY_UNDER_PRIVATE_OR_PUBLIC_LAW,
	RelanceRole.PERSON,
	RelanceRole.LOCAL_PROVINCIAL_GOVERNMENTS,
	RelanceRole.AUTONOMOUS_MUNICIPAL_PROVINCIAL_COMPANIES,
	RelanceRole.NON_PROFIT_ORGANIZATIONS,
];
